import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { deleteBiometricOfCustomer, getListCustomer } from '../../../../../../actions/biometricExecution'
import ButtonConfirmPopup from '../../../Control/ButtonConfirmPopup'
import OverlayFullScreen from '../../../Control/OverlayFullScreen'
import { WrapPopupConfirmDelete } from './index.styles'
import TextAreaControl from '../../../Control/TextAreaControl'
import { color } from '../../../../../../data/store'


export default function PopupConfirmDelete({ onClose, onClosePopupInfos, data, handleDeleteError }) {
    const dispatch = useDispatch()
    const CifsNum = useSelector(state => state.biometricExecutionReducer.CifsNum)

    const [valueReason, setValueReason] = useState("")

    const getTextReason = (value) => {
        setValueReason(value)
    };

    const callbackError = (code) => {
        handleDeleteError(code)
        onClose()
    }

    const callbackSuccess = () => {
        dispatch(getListCustomer(CifsNum))
        onClose()
        onClosePopupInfos()
    }

    const handleDeleteBio = () => {
        if (!valueReason) return
        dispatch(deleteBiometricOfCustomer(
            data.BioInfos.CustomerNumber,
            valueReason,
            callbackSuccess,
            callbackError)
        )
    }

    return (
        <OverlayFullScreen>
            <WrapPopupConfirmDelete>
                <div className="row_question">
                    <span className="img_question"></span>
                </div>
                <div className="row_title">
                    <p className="title">Xác nhận xoá dữ liệu STH</p>
                </div>
                <div className='note'>(*) Vui lòng nhập lý do xoá dữ liệu STH</div>
                <TextAreaControl
                    placeHolder={"... Nhập lý do"}
                    getText={getTextReason}
                />
                <div className="row_btn_confirm">
                    <div className="btn_exit">
                        <ButtonConfirmPopup
                            titleConfirm="HỦY BỎ"
                            bg_color="rgb(215, 18, 73)"
                            onClick={onClose}
                        />
                    </div>
                    <div className="btn_accept">
                        <ButtonConfirmPopup
                            //isDisabled={valueReason ? false : true}
                            titleConfirm="XÁC NHẬN"
                            bg_color={color.blue_005993}
                            onClick={handleDeleteBio}
                        />
                    </div>
                </div>
            </WrapPopupConfirmDelete>
        </OverlayFullScreen>
    )
}
